import { Component, OnInit, HostListener, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { BottombarComponent } from '../../components/bottombar/bottombar.component';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { PushNotificationService } from '../../_utils/push-notification/push-notification.service';
import { PwaService } from '../../_utils/pwa/pwa.service';

@Component({
    selector: 'app-full',
    templateUrl: './full.component.html',
    styleUrl: './full.component.scss',
    imports: [NavbarComponent, RouterOutlet, BottombarComponent, Bind, Dialog, Button]
})
export class FullComponent {
  message: any = { visible: false, text: '', title: ''};
  pullProgress = signal(0);
  reloading = signal(false);
  private PULL_START_THRESHOLD = 20; // Mostra il loader dopo {x}px
  private PULL_RELOAD_THRESHOLD = 150; // Attiva il reload a {x}px

  constructor(protected router: Router, private pwaService: PwaService) { }

  @HostListener('window:scroll', ['$event'])
  onSwipe(event: any) {
    if (!this.pwaService.isInstalled()) return;

    const scrollY = window.scrollY;
    
    // Se si scrolla verso l'alto (scrollY negativo)
    if (scrollY < 0) {
      const absScroll = Math.abs(scrollY);
      
      // Mostra il loader solo dopo il threshold iniziale
      if (absScroll >= this.PULL_START_THRESHOLD) {
        // Calcola il progresso da PULL_START_THRESHOLD a PULL_RELOAD_THRESHOLD
        const progress = Math.min(
          ((absScroll - this.PULL_START_THRESHOLD) / (this.PULL_RELOAD_THRESHOLD - this.PULL_START_THRESHOLD)) * 100,
          100
        );
        this.pullProgress.set(progress);
        
        // Quando raggiunge 100%, attiva il reload
        if (progress >= 100 && !this.reloading()) {
          this.reloading.set(true);
          this.pullProgress.set(0);
          event.preventDefault();
          setTimeout(() => document.location.reload(), 600);
        }
      } else {
        this.pullProgress.set(0);
      }
    } else {
      // Reset quando si smette di scrollare verso l'alto
      if (this.pullProgress() > 0 && !this.reloading()) {
        this.pullProgress.set(0);
      }
    }
  }
}
